
const breakPoint = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 650,
            md: 960,
            lg: 1280,
            xl: 1600,
        },
    }
}
export default breakPoint